<template>
  <div class="commonLiStyle">
    <top-component></top-component>
    <!-- <div class="bannerFirst" @click="ComeLive"></div> -->
    <div class="commonLiContainer">
      <MyAside></MyAside>
      <div class="commontent">
        <div class="titleMap">馆藏分析平台</div>
        <div class="letterTitle">2020/4/12    23:00</div>
        <div class="threediv">
          武汉云图天翼数字传媒有限公司（原武汉卷藏信息技术有限公司）成立于2008年，其前身是武汉三新书业有限公司馆藏信息部，2010年5月正式注册成立公司，开始独立运营。
        </div>
        <div class="threediv">
          拥有丰富的图书馆馆藏数据是武汉云图天翼数字传媒有限公司的一大优势及特色，截止目前，武汉卷藏信息技术有限公司已拥有全国1800余家图书馆的馆藏数据，累积馆藏书目数据2.83亿余条，其中完全不重复的书目数据380万余条，对全国出版社出版的适合馆配的图书品种数覆盖率达95%以上。
        </div>
        <div class="threediv">
          经过近些年的不断探索与研究，云图天翼目前已形成为一家集研究、开发、分析、咨询为一体的专业馆藏文献资源信息服务公司。在积累了大量中文图书馆藏信息的基础上，自主研发了“JC中文图书馆藏分析系统”，凭借丰富的馆藏信息资源及自身强大的技术力量，最终形成以馆藏分析平台为依托的信息咨询服务模式。2.83亿余条，其中完全不重复的书目数据380万余条，对全国出版社出版的适合馆配的图书品种数覆盖率达95%以上。
        </div>
        <div class="threediv">
          目前云图天翼的馆藏数据服务主要涵盖对出版社、对图书馆以及对媒体三个方面，以下是具体的介绍：2.83亿余条，其中完全不重复的书目数据380万余条，对全国出版社出版的适合馆配的图书品种数覆盖率达95%以上。
        </div>
        <div class="titleMap"> 对图书馆</div>
        <div class="threediv">
          针对图书馆的信息服务为适应书业信息情报发展需要，满足出版业和馆配的需求，对馆藏及出版结构进行综合性分析，得出具有普遍参考意义的共同关注点和特别关注点，并结合各个馆藏机构的需求重点和方向，更高层次搭建出版社与图书馆交流的信息平台。2.83亿余条，其中完全不重复的书目数据380万余条，对全国出版社出版的适合馆配的图书品种数覆盖率达95%以上。
        </div>
        <div class="threediv">
          截至目前我公司已经为近1300余家图书馆机构提供过馆藏数据分析及相关信息服务，包括对北京大学、华中科技大学、同济大学、中南大学、西北工业大学、福州大学、东北林业大学、天津大学等多所211工程高校图书馆，以及山东省、安徽省、山西省、贵州省等公共馆，对图书馆的馆藏资源优化、采购方案的确定及查缺补漏都有较大的参考意义。图书馆可根据馆里的实际情况提出其他的需求，主要有本馆馆藏结构变化、与他馆的比较等内容。2.83亿余条，其中完全不重复的书目数据380万余条，对全国出版社出版的适合馆配的图书品种数覆盖率达95%以上。
        </div>
        <div>
          <img src="../../assets/images/guan.png">
        </div>
        <div>
          <img src="../../assets/images/guan1.png">
        </div>
        <div class="titleMap"> 对出版社</div>
        <div class="threediv">
          对出版社主要是提供两大服务产品——出版社客户端和馆配分析报告，两大产品相互补充，通过分析图书的馆配流向及流量，为出版社有针对性的开展馆配工作等提供参考。同时，我们亦可利用自身的图书馆新书服务平台，有针对性地将出版社的书目信息投向对应馆藏机构，有助于其扩大馆配销售，改善业务表现。2.83亿余条，其中完全不重复的书目数据380万余条，对全国出版社出版的适合馆配的图书品种数覆盖率达95%以上。
        </div>
        <div class="threediv">
          1、云图天翼信息服务数据说明
        </div>
        <div class="threediv">
          云图天翼所提供的产品涉及到的馆配数据均来自于“JC中文图书馆藏分析系统”。 云图天翼一直秉承为客户提供最优质的服务为理念，截至目前年在已拥有的1800余家图书馆中选取最优质、并且能时时更新的1300家图书馆数据，采样范围遍布全国 30个省、自治区、直辖市的图书馆，采样数据逐年增加。
        </div>
        <div>
          <img src="../../assets/images/guan3.png">
        </div>
        <div class="threediv">
          2、产品服务——出版社客户端
        </div>
        <div class="threediv">
          出版社客户端（即JC Publish Client），是武汉云图天翼数字传媒有限公司独立研发的馆配信息查询系统，主要用于追踪图书在馆配领域的流向与流量，是图书发行渠道中各环节信息沟通的对接平台，为图书的出版和馆配提供具有实际意义的参考数据。通过该客户端，出版社用户可了解馆配市场全貌、竞争格局及自身在馆配市场的地位，有助于出版机构准确掌握本社图书的具体馆配流向、同类图书的馆配概况，单个图书馆缺藏本版的书目，随时把握馆配动态，为其简易直观地悉知市场情况、制定馆配战略、有针对性地开展馆配工作等提供科学依据。
        </div>
        <div>
          <img src="../../assets/images/guan4.jpeg">
        </div>
        <div class="threediv">
          3、产品服务——馆配分析报告
        </div>
        <div class="threediv">
          馆配分析报告主要是从宏观把握的层面，对馆配市场全貌、竞争格局、出版选题策划、馆配畅销书等多个方面的信息进行整合，有助于出版社掌握当前整体及本社的图书馆配概况，各项馆配的排行，以及同类型竞争出版社的馆配概况，为出版社简易直观地了解市场情况，制定馆配及出版战略提供科学依据。云图天翼提供的馆配分析报告主要有季度、（半）年度等5大类型，“私人订制”特色主题报告可根据出版机构的具体需求进行“量身定做”。
        </div>
        <div>
          <img src="../../assets/images/guan5.png">
        </div>
        <div class="threediv">
          自成立以来，我公司一直执着追求“没有最好，只有更好”的理念，在10年间不断地探索和创新，争取以更优质的产品为客户提供更好的服务，在产品报告中增加了不少的亮点，如本社在整体馆配市场的码洋估算、本社的馆配滞销书、馆配畅销书与零售市场畅销书的比较分析等等，均获得了客户的一致认可。
        </div>
        <div class="titleMap"> 对媒体</div>
        <div class="threediv">
          1、中国出版传媒商报
        </div>
        <div class="threediv">
          自2011年开始，云图天翼的信息服务模式更为优化，作为全国首家联系馆配与出版的信息服务桥梁，云图天翼联手国内权威书业媒体第一报——中国出版传媒商报，定期发布行业内相关馆配数据，为整体馆配市场提供最新、最全面的行情动态，获得了业界的高度关注与认可。截止目前，与中国出版传媒商报合作已10年，“商报·卷藏”数据已发布近50期。
        </div>
        <div>
          <img src="../../assets/images/guan6.png">
        </div>
        <div class="threediv">
          2、云图天翼官方微信平台
        </div>
        <div class="threediv">
          云图天翼官方微信（微信号：juancang2008）每周不定期发布相关数据报告及行业新闻，更及时的馆配动态、畅销图书共享，掌握最新中文图书馆配市场动态变化！敬请关注武汉卷藏馆配数据发布！
        </div>
        <div>
          <img src="../../assets/images/guan7.jpeg">
          <div>手机微信扫一扫，馆配市场尽揭晓！</div>
        </div>
        <div class="threediv">
          联系电话： 027—51850969
        </div>
        <div class="threediv">
          出版社QQ：745929179
        </div>
        <div class="threediv">
          图书馆QQ：1310550032
        </div>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import MyAside from '@/components/MyAside.vue'
  export default {
    name: 'SchoolLibrary',
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      ComeLive() {
        // 1、后台如果设置了默认直播，就传过去默认直播的id，否则就传0
        // 2、HomePage: true; 用来判断是不是从首页进入的，
        // 首页进来的话，优先播放和服务器时间对的上的直播，
        // 其次是查看有没有默认直播，
        // 上面都没有满足的话就展示没有直播提醒的提示
        // 3、直播页中直接点击议程跳转到新的页面，就展示点击的议程的直播 Cookies.set('linkUrl', item.linkUrl) Cookies.get('linkUrl')
        this.$router.push({ name: 'LookLiveG', params: { webinarId: 0 } })
        Cookies.set('HomePage', true)
        Cookies.set('playType', 1)
        Cookies.set('playUrl', 'null')
      }
    },
    components: {
      BottomComponent,
      TopComponent,
      [MyAside.name]: MyAside
    },
  }
</script>

<style scoped lang="scss">
  .commonLiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* banner */
  .bannerFirst {
    height: 67px;
    cursor: pointer;
    background: url('../../assets/images/NewBanner.png') no-repeat center center;
    background-size: auto 100%;
  }

  /* 公共 */
  .commonLiContainer {
    display: flex;
    justify-content: center;
    padding: 60px 50px;
    background-color: #FFDDB0;
  }

  .commontent {
    padding: 74px 100px 50px 100px;
    background-color: #fff;
    font-family: PingFang-SC-Bold;
  }

  /* title */
  .titleMap {
    color: #000;
    font-size: 40px;
  }

  .letterTitle {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 68px;
  }

  /* 1 */
  .twodiv {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    line-height: 25px;
    text-align: left;
  }

  /* 2 */
  .threediv {
    margin: 20px auto;
  }

  img {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Product-Guancang.vue